export enum UserBankBranchStatus {
  Pending = 1,
  Rejected = 2,
  Verified = 3,
  Blocked = 4
}

export enum BankTransactionType {
  plus = 1,
  minus = 2
}

export enum BankTransactionStatus {
  draft,
  cofirm,
  reject
}

export type BankTransactionStatusName = 'draft' | 'confirm' | 'reject';
